'use strict';

const Node = require('system/domain/entity/node');
const Backbone = require('backbone');

module.exports = Backbone.Collection.extend({
    model: Node
});



// WEBPACK FOOTER //
// ./system/domain/collection/node.js